import styled from "styled-components";



export const FilterTabsList = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
`;

export const FilterTab = styled.div`
  padding: 0 24px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 32px;
  cursor: pointer;
  gap: 6px;
  background-color: ${props => props.active ? '#2555EF' : '#FFFFFF'};
  color: ${props => props.active ? '#FFFFFF' : '#4D5565'};

`;

export const FilterTabText = styled.div`
  font-weight: bold;
  font-size: 13px;
`;


export const FilterDot = styled.div`
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background-color: ${props => props.color};
`